<template>
  <sidebar>
    <div class="col-md-12 pt-5 pb-5 pr-2 pl-2">
      <div class="col-md-12 d-flex flex-column align-items-start justify-content-center">
        <div class="col-md-12 p-0"> 
          <h3 class="pb-2">Sobre a Fêmea:</h3>
          <v-autocomplete
            outlined
            placeholder="Selecione a Fêmea"
            item-value="id"
            item-text="name"
            :items="computedHeadquarters"
            style="width:70%"
            return-object
            v-model="animal_birth.matrix"
            @update:search-input="searchAnimal"
            @change="checkAnimal"
            no-data-text="Nenhum resultado..."
            clearable
          ></v-autocomplete>
        </div>
      </div> 

      <div class="col-md-12 d-flex justify-content-between border-botton"  style="padding-bottom:5%;" v-if="animal_birth.matrix">
        <div class="col-md-4 p-0 d-flex align-items-center">
          <h4 class="m-0">Data de Nascimento: {{animal_birth.matrix.born_at || "—"}}</h4>
        </div>
        <div class="col-md-3 p-0 d-flex align-items-center">
          <h4 class="m-0">Registro: {{animal_birth.matrix.register || "—"}}</h4>
        </div>

        <div class="col-md-3 p-0 d-flex align-items-center">
          <h4 class="m-0">Grau de Sangue: {{animal_birth.matrix.degree_blood || "—"}}</h4>
        </div>
      </div>

      <div style="margin-top:5%;">
        <div class="col-md-12 d-flex justify-content-between">
          <div class="col-md-5 p-0 d-flex flex-column justify-content-center">
            <h4>Sobre o Parto:</h4>
            <date-picker
              label="Data do Parto"
              :binding.sync="animal_birth.date"
              :readOnly="false"
              @updateDate="getOrder"
              @typing="getOrder"
              :errorsMessages="dateError"
              :disabled="disableDate"
              :maxDate="today"
              @dateErrors="dateInvalid = $event"
            ></date-picker>
          </div>
          <div class="col-md-5 p-0 d-flex align-items-center">
            <v-select
              outlined
              label="Ordem do parto"
              :items="orders"
              item-text="name"
              item-value="name"
              style="height:60px"
              v-model="animal_birth.order"
              :disabled="!!animal_birth.id"
              no-data-text="Nenhum resultado"
              clearable
          ></v-select>
          </div>
        </div>
        <div class="col-md-12">
          <v-select
            outlined
            placeholder="Tipo de Parto"
            :items="computedKindBirth"
            item-text="title"
            item-value="name"
            style="height:60px"
            v-model="animal_birth.kind_birth"
            :error-messages="kindBirthErrors"
            clearable
          ></v-select>
        </div>
      </div>

      <div :class="{disabled: noChild}" class="col-md-12 d-flex flex-column justify-content-between" style="margin-top:5%">
        <div class="col-md-12 p-0">
          <h4>Sobre a Cria:</h4>
          <v-text-field 
            outlined label="Identificação"
            v-model="animal_birth.name_child"
          ></v-text-field>
        </div>

        <div class="col-md-12 p-0">
          <v-select
              outlined
              :items="computedConditions"
              item-text="title"
              item-value="name"
              label="Condição da Cria"
              v-model="animal_birth.condition_child"
              clearable
              :error-messages="childConditionErrors"
            ></v-select>
        </div>

        <div class="col-md-12 p-0 d-flex justify-content-between">
          <div class="col-md-5 p-0 d-flex flex-column">
            <v-select
              outlined
              :items="computedGender"
              item-text="name"
              item-value="id"
              label="Sexo"
              v-model="animal_birth.gender_child"
              clearable
              :error-messages="genderChildErrors"
            ></v-select>
            <v-text-field 
              label="Botton" 
              outlined
              v-model="animal_birth.bottom_child"
            ></v-text-field>
          </div>

          <div class="col-md-5 p-0 d-flex flex-column">
            <v-text-field 
              label="Peso da Cria" 
              outlined suffix="KG"
              v-model="animal_birth.weight_child"
            ></v-text-field>

            <v-select
              outlined
              :items="computedDegreeBlood"
              item-text="name"
              item-value="id"
              label="Grau de Sangue"
              v-model="animal_birth.degree_blood"
              clearable
            ></v-select>
          </div>
        </div>
      </div>

      <div class="col-md-12 d-flex justify-content-center" style="margin-top:10%">
        <v-btn 
          id="save"
          class="success" 
          @click="showConfirmationModal"
          :disabled="!canSave"
        >{{isEdition ? "Editar Parto" : "Registrar Parto"}}</v-btn>
        <v-btn outlined class="btn-back ml-5" @click="SET_ACTIVE(false);">Voltar</v-btn>
      </div>

      <modal-confirmation 
        :confirm="showConfirmation"
        title="Confirmação"
        text="Tem certeza que deseja registrar este parto ?"
        @close="showConfirmation = false"
        @save="saveBirth"
      />

      <modal-alert 
        :active="alertModal"
        :openBirth="openBirth"
        @close="alertModal = false"
      />
      
      <modal-alert-born-at
        :active="alertModalDoestHaveBornAt"
        @close="alertModalDoestHaveBornAt = false"
      />

      <modal-alert-cannot-birth
        :count="monthsCannotBirth"
        :active="showAlertCannotBirth"
        :animal="animalCannotBirth"
        @close="showAlertCannotBirth = false"
      />

      <modal-alert-death 
        :active="showModalDeath"
        @close="showModalDeath = false"
      />

      <modal-alert-date 
        :active="showModalAlertDate"
        @close="showModalAlertDate = false"
      />
    </div>
  </sidebar>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar.vue";
import DatePicker from "@/components/layout/DatePicker";
import {mapActions, mapState, mapMutations} from "vuex";
import helpers from "@/mixins/helpers.js";
export default {
  name:"SidebarBirth",
  mixins:[helpers],
  props:{
    service:Object,
    matrix:Object,
    edit:Object
  },
  components: {
    Sidebar,
    DatePicker,
    ModalConfirmation: () => import("@/components/layout/ModalConfirmation"),
    ModalAlert: () => import("./ModalAlert.vue"),
    ModalAlertBornAt: () => import("./ModalAlertBornAt.vue"),
    ModalAlertCannotBirth: () => import("./ModalAlertCannotBirth.vue"),
    ModalAlertDeath: () => import("./ModalAlertDeath.vue"),
    ModalAlertDate: () => import("./ModalAlertDate.vue")
  },
  data() {
    return {
      dateError:"",
      showConfirmation:false,
      dateInvalid:false,
      showModalAlertDate:false,
      monthsCannotBirth:15,
      animal_birth:{},
      matrix_name:null,
      orders:[],
      animals:[],
      alertModal:false,
      openBirth:{},
      doenstHaveBornAt:{},
      alertModalDoestHaveBornAt:false,
      canSave:true,
      showAlertCannotBirth:false,
      animalCannotBirth:{},
      showModalDeath:false,
      disableDate:false
    }
  },
  computed: {
    ...mapState("animals", [
      "headquarters",
      "kinds_birth",
      "degree_blood",
      "child_conditions"
    ]),
    ...mapState("sidebar", [
      "active"
    ]),
    ...mapState("creators", [
      "creators"
    ]),
    ...mapState("farms", [
      "farms"
    ]),
    computedKindBirth() {
      return this.kinds_birth.map((e, i) => ({...e, title:(i + 1) + " - " + e.name}));
    },
    computedConditions() {
      return this.child_conditions.map((e, i) => ({...e, title:(i + 1) + " - " + e.name}));
    },
    computedDegreeBlood() {
      return this.degree_blood;
    },
    computedGender() {
      return [
        {name:"Macho", id:"m"},
        {name:"Fêmea", id:"f"},
        {name:"Gêmeos (Machos)", id:"mm"},
        {name:"Gêmeos (Fêmeas)", id:"ff"},
        {name:"Gêmeos (Sexo Diferente)", id:"fm"},

      ]
    },
    isEdition() {
      if(this.animal_birth.id) {
        return true;
      } 
      else {
        return false;
      }
    },
    computedHeadquarters() {
      return this.animals.map(e => ({...e, name:e.code + " - " + e.name + " Registro: " + e.register}));
    },
    // YYYY-MM-DD local (toISOString seria UTC: à noite já é amanhã)
    today() {
      const d = new Date();
      return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    },
    // N5: sem cria em lactação induzida, aborto e parto não informado
    noChild() {
      return ["Lactação induzida", "Aborto", "Parto não informado"].includes(this.animal_birth.kind_birth);
    },
    childConditionErrors() {
      return this.animal_birth.kind_birth && !this.noChild && !this.animal_birth.condition_child ? ["Condição da Cria é obrigatória"] : [];
    },
    genderChildErrors() {
      return this.animal_birth.kind_birth && !this.noChild && !this.animal_birth.gender_child ? ["Sexo da Cria é obrigatório"] : [];
    },
    kindBirthErrors() {
      const errors = [];
      if(this.animal_birth.matrix && !this.animal_birth.kind_birth) errors.push("Tipo de Parto é obrigatório");
      if(
        this.animal_birth.date &&
        this.animal_birth.kind_birth === "Aborto" ||
        this.animal_birth.date &&
        this.animal_birth.kind_birth === "Prematuro"
      ) {
        /* const thisBirth = Math.round(new Date(this.animal_birth.date).getTime() / 1000);
        const lastBirthday = Math.round(new Date(this.parseDate(this.animal_birth.matrix.last_birthday)).getTime() / 1000);
        //18.144.000 é o equivalente a 210 dias em unix timestamp
        if(thisBirth - 18144000 > lastBirthday) {
          errors.push("Ao informar tipo do parto prematuro ou aborto, a diferença desse parto com o anterior não pode ser inferior a 210 dias");
        } */
        return errors;
      } else {
        return errors;
      }
    }
  },
  methods: {
    ...mapActions("animals", [
        "actionGetAnimalsHeadquarters", 
        "actionSaveAnimalBirth",
        "actionEditAnimalBirth", 
        "actionSearchAnimalsGeneral",
        "actionGetAvailableOrders"
      ]),
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("farms", ["actionGetFarms"]),
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    showConfirmationModal() {
      if(!this.animal_birth.date || this.dateInvalid) {
        this.$toast.error("Data do parto é obrigatória e não pode ser maior que hoje");
        return
      }
      if(this.kindBirthErrors.length || this.childConditionErrors.length || this.genderChildErrors.length) {
        this.$toast.error([...this.kindBirthErrors, ...this.childConditionErrors, ...this.genderChildErrors].join(" / "));
        return
      }
      this.showConfirmation = true
    },
    async getOrder() {
      if(this.animal_birth.matrix && this.animal_birth.date.replace(/[^0-9]/gim, '').length > 7) { 
        this.checkInterval();
        this.orders = await this.actionGetAvailableOrders({animal:this.animal_birth.matrix.id,date:this.animal_birth.date});
      } else {
        return 
      }
    },
    checkInterval() {
      const thisBirth = Math.round(new Date(this.animal_birth.date).getTime() / 1000);
      const lastBirthday = Math.round(new Date(this.parseDate(this.animal_birth.matrix.last_birthday)).getTime() / 1000);
      //18.144.000 é o equivalente a 210 dias em unix timestamp
      if(thisBirth - 18144000 > lastBirthday) {
/*         this.canSave = false;
        this.$toast.error("Não pode ser cadastrado novo parto para animais com um parto com menos de 210 dias de diferença."); */
      } else {
        this.canSave = true;
      }
    },
    async getFarms(value) {
      await this.actionGetFarms(value);
    },
    async getHeadquarters(value) {
      await this.actionGetAnimalsHeadquarters(value);
    },
    async saveBirth() {
      if(this.dateInvalid) return;
      if(this.animal_birth.matrix) {
        this.animal_birth.matrix_id = this.animal_birth.matrix.id;
      }
      if(this.service.id && this.service.farm) {
        this.animal_birth.service_id = this.service.id;
        this.animal_birth.farm_id = this.service.farm.id || this.service.farm;
      }
      if(!this.animal_birth.order) {
        this.animal_birth.order = Math.min(...this.orders.map(e => {return e}));
      }
      try {
        if(this.edit?.id) {
          const payload = {
            date:this.animal_birth.date,
            kind_birth:this.animal_birth.kind_birth,
            condition_child:this.noChild ? null : this.animal_birth.condition_child,
            degree_blood:this.animal_birth.degree_blood,
            farm_id:this.animal_birth.farm_id,
            id:this.animal_birth.id
          }
          await this.actionEditAnimalBirth(payload);
        } else {
          const postPayload = {...this.animal_birth};
          delete postPayload.matrix;
          // sem cria (LI/aborto/não informado): o que foi digitado na seção desabilitada não vai
          // (criaria a cria e o gender_child sobreporia o implícito ABORTO/INDUÇÃO — revisão J4)
          if(this.noChild) ["name_child", "gender_child", "condition_child", "weight_child", "bottom_child"].forEach(k => delete postPayload[k]);
          await this.actionSaveAnimalBirth(postPayload);
          this.$emit("refresh-services");
          this.canSave = false;
        }
        this.$toast.success(this.animal_birth.id ? "Parto editado com sucesso !" : "Parto registrado com sucesso !");
        this.animal_birth = {};
      } catch(error) {
        this.$toast.error(`${error}`)
      }
      this.showConfirmation = false;
      delete this.$route.params.service;
    },
    //Esse metodo busca animais em todas as tabelas do banco vinculada a este usuário
    async searchAnimal(data) {
      if(!this.animal_birth.matrix && data && data.length > 2) {
       const farm = this.service && this.service.farm;
       this.animals = await this.actionSearchAnimalsGeneral({register:data, code:data, ...(farm ? {farm: farm.id || farm} : {})});
      } else {
        this.aniamls = [];
      }
    },
    returnDate(date) {
      const [day,month,year] = date.toString().split("-");
      return year+"-"+month+"-"+day;
    },
    async checkAnimal(data) {
      if(data.active === false) {
        this.showModalDeath = true;
      }
      else if(data && data.current_birthday_id) {
        this.openBirth = data;
        this.alertModal = true;
      }
      else if(data && !data.born_at) {
        this.doenstHaveBornAt = data;
        this.alertModalDoestHaveBornAt = true;
      }
    },
    checkIfCanGiveBirth() {
      // na edição a matriz vem enxuta (N1, sem born_at): não há o que checar
      if(this.animal_birth.matrix && this.animal_birth.matrix.born_at && this.animal_birth.date) {
        // sistema do Rapha: parto com menos de 15 meses de idade bloqueia; menos de 17, só alerta
        const born = new Date(this.returnDate(this.animal_birth.matrix.born_at) + "T00:00:00");
        const date = new Date(this.animal_birth.date + "T00:00:00");
        const plusMonths = n => new Date(born.getFullYear(), born.getMonth() + n, born.getDate());
        if(date < plusMonths(17)) {
          this.monthsCannotBirth = date < plusMonths(15) ? 15 : 17;
          this.showAlertCannotBirth = true;
          this.animalCannotBirth = this.animal_birth.matrix;
          this.canSave = this.monthsCannotBirth === 17;
        } 
        /* else if(date < (last_birthday + 18144000) && this.animal_birth.kind_birth === "Aborto") {
          this.dateError = "Parto com tipo Aborto não pode ser cadastrado com menos de 210 dias do último parto.";
          this.canSave = false;
        }
        else if(date < (last_birthday + 18144000) && this.animal_birth.kind_birth === "Prematuro") {
          this.dateError = "Parto com tipo Prematuro não pode ser cadastrado com menos de 210 dias do último parto.";
          this.canSave = false;
        } */
        else {
          this.canSave = true;
        }
      }
    },
  },
  watch: {
    async edit(val) {
      if(val.id) {
        this.animal_birth = {
          name_child:val.name_child,
          matrix:val.matrix,
          date:this.parseDate(val.date),
          condition_child:val.condition_child,
          order:val.order,
          kind_birth:val.kind_birth,
          gender_child:val.gender_child,
          bottom_child:val.bottom_child,
          degree_blood:val.degree_blood,
          weight_child:val.weight_child,
          id:val.id,
        }
        this.animals = await this.actionSearchAnimalsGeneral({register:val.matrix.name});
        this.orders = [val.order];
        this.matrix_name = val.matrix?.name;
      }
      else {
        this.animal_birth = {};
      }
    },
    active(val) {
      if(val && !this.edit) {
        this.animal_birth = {};
        this.orders = [];
      }
      if(val && this.service.animal){
        this.matrix = this.service.animal;
        if(this.computedHeadquarters.length === 0) {
          this.computedHeadquarters.push(this.service.animal);
        }
      }
    },
    async matrix(val) {
      if(this.animals.length === 0 && this.matrix) {
        this.animals.push(val);
        this.animal_birth.matrix = val;
        if(this.animal_birth.date) {
          this.orders = await this.actionGetAvailableOrders({animal:val.id, date:this.animal_birth.date});
        }
      }   
    },
    dateInvalid(val) {
      if(val) this.showModalAlertDate = true;
    },
    kindBirthErrors(val) {
      if(val.length) {
        this.canSave = false;
      } else {
        this.canSave = true;
      }
    },
    "animal_birth.date": function() {
      this.checkIfCanGiveBirth();
    },
    "animal_birth.matrix": function() {
      this.checkIfCanGiveBirth();
    },
    "animal_birth.kind_birth": function(val) {
      this.checkIfCanGiveBirth();
      const lastWeight = this.animal_birth.matrix && this.animal_birth.matrix.last_weight;
      if(val === "Lactação induzida" && lastWeight && lastWeight !== "N/D") {
        const last_weight = new Date(this.parseDate(this.animal_birth.matrix.last_weight)).getTime();
        const sixth_day_before = new Date(last_weight - (432000 * 1000));
        let day = sixth_day_before.getDate();
        let month = sixth_day_before.getMonth() + 1;
        const year = sixth_day_before.getFullYear();
        if(day <= 9) {
          day = "0" + day;
        }
        if(month <= 9) {
          month = "0" + month;
        }
        this.animal_birth.date = year+"-"+month+"-"+day;
        this.disableDate = true;
      } else {
        this.disableDate = false;
      }
    }
  },
  async mounted() {
    document.addEventListener("keypress", (e) => {
      if(this.active === true) {
        if(e.key === "Enter") {
          this.showConfirmationModal(); // mesmas validações do botão (antes o Enter pulava todas)
        }
      }
    });
    await this.actionGetCreators();
  }
}
</script>

<style scoped>
  h3 {
    font-size: 1.2rem;
  }

  h4 {
    font-size: 1rem;
  }
  .border-botton {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
</style>